import { api } from '@/services/api/axios/instance';
import { formatError } from '@/services/api/axios/transform';
import { AxiosResponse } from 'axios';

export type ProductAdminRole = {
  productName: string;
  role: string;
  helpUrl: string;
};

export type ProductAdminRolesResponse = {
  productAdminRoles: ProductAdminRole[];
};

const getProductAdminRoles = async (
  organizationId: number,
  config?: { params: { lang: string } },
): Promise<ProductAdminRolesResponse> => {
  try {
    const response: AxiosResponse<ProductAdminRolesResponse> = await api.get(
      `/organizations/${organizationId}/product_admin_roles`,
      config,
    );
    return response.data;
  } catch (error: any) {
    throw formatError(error);
  }
};

export const productAdminRolesApi = {
  getProductAdminRoles,
};
